import React from "react";
import PropTypes from "prop-types";
import { ShareFill, Fullscreen } from "react-bootstrap-icons";

export function GameContainer({ gameName, gameUrl }) {
  const goFullScreen = () => {
    const ele = document.getElementById("game_frame");
    var requestMethod =
      ele.requestFullScreen ||
      ele.webkitRequestFullScreen ||
      ele.mozRequestFullScreen ||
      ele.msRequestFullScreen;

    if (requestMethod) {
      // Native full screen.
      requestMethod.call(ele);
    } else {
      alert("browser doesn't support full screen");
    }
  };

  return (
    <div className="relative">
      <div className="game_frame_top">&nbsp;</div>
      <div className="game_frame_bottom">&nbsp;</div>
      <div className="game_box_outer">
        <span className="game_box_name">{gameName}</span>
        <div className="row">
          <div className="col game_box_inner">
            <iframe
              id="game_frame"
              src={gameUrl}
              width="100%"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="row">
          <div className="col text-right">
            {/* <button className="btn-white topgap20">
              <ShareFill className="rightgap12" /> Share
            </button> */}
            <button
              className="btn-white leftgap20 topgap20"
              onClick={goFullScreen}
            >
              <Fullscreen className="rightgap12" />
              Full Screen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GameContainer;

GameContainer.propTypes = {
  gameName: PropTypes.string.isRequired,
};
